import styled from 'styled-components'

interface IVendorContactInformationStyledProps {}

export const VendorContactInformationStyled = styled.div<IVendorContactInformationStyledProps>`
  font-size: ${(props) => props.theme.typography.pxToRem(16)};
`
